<div class="header-bar">
  <h1>Order Dump</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <form (ngSubmit)="onSubmit()" style="width: 100%">
        <div class="ui-g filterPanel">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input name="orderId" type="text" required pInputText [(ngModel)]="dataNumber" />
              <label>Job number/Order number</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-8">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clear()"></button>
            <a
              class="ui-widget ui-corner-all ui-button ui-button-text-only ui-button-danger btn-to-right"
              *ngIf="order"
              [href]="downloadData"
              download="{{ downloadFileName }}"
            >
              <span class="ui-button-text ui-clickable">Download</span>
            </a>
          </div>
        </div>
      </form>
      <div class="ui-g">
        <div *ngIf="order" class="ui-g-12">
          <pre class="json-result">{{ order | json }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
